module.exports = __webpack_public_path__ + "img/26.7e1403bb.jpg";